module.exports = __webpack_public_path__ + "static/media/modify_appointment.d3cd57a4.svg";